import styled from "styled-components/macro";
import {DefaultFont} from "../../../styles/fonts";

export const NewsSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  align-items: center;
  margin-bottom: 10em;
  gap: 2rem;
  
  .image {
    flex: 1 1 45%;
    width: 100%;
    height: 100%;
    max-width: 50em;
    min-width: 20em;
    border-radius: 8px;
  }
  
  & > div {
    flex: 1 1 45%;
  }
  
  & > div > div {
    margin-top: 1rem;
    & > svg {
      vertical-align: middle;
      margin-right: 1ex;
    }
  }

  @media ${(props) => props.theme.media.phone} {
    margin-bottom: 3em;
  }
`;

export const AboutSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  margin-bottom: 10em;

  .image {
    flex: 1 1 45%;
    width: 100%;
    height: 100%;
    max-width: 50em;
    min-width: 20em;
    border-radius: 8px;
  }

  & > div {
    flex: 1 1 45%;
    & > button {
      white-space: nowrap;
    }
  }

  @media ${(props) => props.theme.media.phone} {
    margin-bottom: 3em;
  }
  
  
`;

export const Releases = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 10em;
  
  & > div {
    flex: 1 0 30%;
    & > img {
      aspect-ratio: 16/9;
      min-width: 16em;
    }
  }

  @media ${(props) => props.theme.media.phone} {
    margin-bottom: 3em;
  }
`;

export const News = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  
  & > div {
    flex: 1 0 30%;
    background-color: #FFF7F3;
    border-radius: 8px;
    padding: 1.5em;
    min-width: 15em;
    cursor: pointer;
  }
  
  h2 {
    ${DefaultFont};
    color: ${(props) => props.theme.text.color.blueDimmed};
  }
`;

export const Resources = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 10em;
  
  & > div {
    cursor: pointer;
  }

  svg {
    vertical-align: middle;
    margin-left: 1ex;
  }

  @media ${(props) => props.theme.media.phone} {
    margin-bottom: 3em;
  }
`;

export const SectionHeader = styled.h3`
  ${DefaultFont};
  color: ${(props) => props.theme.text.color.orange};
  margin-bottom: 0.7em;
`;
